import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DocumentEnum } from './../../services/documentsOperation/DocumentEnum';
import { Observable } from 'rxjs';
import { RestAPIService } from '../restAPI/rest-api.service';
@Injectable({
  providedIn: 'root',
})
export class S3ServiceService {
  constructor(
    private http: HttpClient,
    private restApiService: RestAPIService
  ) {}

  getPutPresignedUrl(
    fileName: string,
    docType: DocumentEnum,
    extension: string
  ): Observable<any> {
    return this.restApiService.get(
      `/api/s3/presigned-url/put?fileName=${fileName}&doctype=${docType}&fileExtension=${extension}`,
      'json'
    );
  }

  getGetPresignedUrl(objectKey: string): Observable<any> {
    return this.restApiService.get(
      `/api/s3/presigned-url/get?objectKey=${objectKey}`
    );
  }

  deleteFileFromS3(cloudPath: string): Observable<any> {
    return this.restApiService.delete(
      `/api/s3/deleteObject?objectKey=${cloudPath}`
    );
  }

  getFileFromS3(url): Observable<Blob> {
    return this.http.get(url, {
      responseType: 'blob',
      headers: new HttpHeaders({}),
    });
  }

  async uploadFileToS3(url: string, file: File): Promise<any> {
    const response = await fetch(url, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    return response;
  }
  getFolderList(prefix) {
    return this.restApiService.get(`/api/s3/list-folders-and-files/${prefix}`);
  }

  deleteFileById(id) {
    return this.restApiService.delete('/api/document/' + id);
  }
}
